export default {
  getInputBorderColor(value, average) {
    const RED = '3px solid #ff5252';
    const YELLOW = '3px solid #ddd122';
    const BLUE = '3px solid #33b8f6';

    if (value === null || average === null || value === undefined || average === undefined) {
      return '';
    }

    const numericValue = Number(value);
    const numericAverage = Number(average);

    if (numericAverage === 0) {
      return numericValue > 0 ? RED : '';
    }

    const percentDifference = Math.abs((numericValue - numericAverage) / numericAverage) * 100;

    if (percentDifference <= 20) {
      return '';
    }
    if (percentDifference > 20 && percentDifference <= 30) {
      return BLUE;
    }
    if (percentDifference > 30 && percentDifference <= 50) {
      return YELLOW;
    }
    return RED;
  }
};
